import React from 'react';

class DashboardScreen extends React.PureComponent {
  render() {
    return <div>DashBoard Screen</div>;
  }
}

export default DashboardScreen;
